import { createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  previewLoadingContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1
  },
  previewContent: {
    flex: 1,
    width: '100%',
    overflow: 'auto'
  }
});
